module.exports = __webpack_public_path__ + "static/media/customer-2.a0dad403.jpg";